const API_URL = 'https://dozc3c6dljuu2ejmtsjl5kfud40ttdar.lambda-url.us-east-1.on.aws/';
//const API_URL = 'https://sdddg6zjijwinyqhomo7c6yxpu0fhnrh.lambda-url.us-east-1.on.aws/';
const BASE_URL = 'https://api.propagile.com/api/v1'; // Cambia esto a tu URL de Sails.js

export const chatbotApi = {
    async getConversations(userUuid) {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'get_conversations', userUuid })
        });
        return this._handleResponse(response);
    },

    async getConversationMessages(userUuid, conversationId) {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                action: 'get_conversation_messages',
                userUuid,
                conversationId
            })
        });
        return this._handleResponse(response);
    },

    async sendMessage({ message, userEmail, userUuid, conversationId, projectId, messageId, sessionId = null, anonymousSessionId = null }) {
        
        const payload = {
            message,
            userEmail,
            userUuid,
            conversationId,
            projectId,
            messageId
        };

        if (sessionId) {
            payload.sessionId = sessionId;
        }

        if (anonymousSessionId) {
            payload.anonymousSessionId = anonymousSessionId;
        }
        
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        return this._handleResponse(response);
    },

    async deleteConversation(userUuid, timestamp,conversationId) {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                action: 'delete_conversation',
                userUuid,
                timestamp,
                conversationId
            })
        });
        return this._handleResponse(response);
    },

    async ping(userUuid) {
        return fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'ping', userUuid: userUuid || null })
        });
    },

     /**
     * Crea el registro inicial del mensaje del usuario
     */
    async createMessageRecord({ 
        messageId, 
        conversationId, 
        userUuid, 
        userEmail, 
        userMessage, 
        projectId,
        subscriptionPlan,
        subscriptionStatus,
        agent_used = 'unknown'
    }) {
        const response = await fetch(`${BASE_URL}/agents/feedback`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                message_id: messageId,
                conversation_id: conversationId,
                user_uuid: userUuid,
                user_email: userEmail,
                user_message: userMessage,
                bot_response: 'PENDING_RESPONSE',
                project_id: projectId || 'Anonimus',
                subscription_plan: subscriptionPlan || 'unknown',
                subscription_status: subscriptionStatus || null,
                agent_used: agent_used || 'unknown',
                response_time_ms: 0,
                user_message_sent_at: Date.now(),
                bot_response_received_at: 0
            })
        });
        return this._handleSailsResponse(response);
    },

    /**
     * Actualiza el registro con la respuesta del bot
     */
    async updateBotResponse({ messageId, botResponse, agentUsed, responseTimeMs, input_tokens, output_tokens }) {        
        const response = await fetch(`${BASE_URL}/agents/feedback`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                message_id: messageId,
                bot_response: botResponse,
                bot_response_received_at: Date.now(),
                agent_used: agentUsed || 'unknown',
                response_time_ms: responseTimeMs || 0,
                input_tokens: input_tokens,
                output_tokens: output_tokens
            })
        });
        return this._handleSailsResponse(response);
    },

    /**
     * Envía el feedback del usuario (rating + comentario)
     */
    async submitFeedback({ messageId, rating, comment }) {
        console.log('Submitting feedback to API:', { messageId, rating, comment });
        const response = await fetch(`${BASE_URL}/agents/feedback`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                message_id: messageId,
                rating: rating || null,
                comment: comment || null
            })
        });
        return this._handleSailsResponse(response);
    },

    // Helper interno para estandarizar las respuestas
    async _handleResponse(response) {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        return data.body ? JSON.parse(data.body) : data;
    },

    async _handleSailsResponse(response) {
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
};